import { render, staticRenderFns } from "./package_input_fields.vue?vue&type=template&id=5a3ce527&"
import script from "./package_input_fields.vue?vue&type=script&lang=js&"
export * from "./package_input_fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports